var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.333c-.307 0-.601.117-.825.325l-9.002 7.797a.5.5 0 1 0 .654.756L3 11.06v9.272a2 2 0 0 0 2 2h4.5a.5.5 0 0 0 .5-.5m0-.003v-5.747a.3.3 0 0 1 .069-.198c.037-.042.074-.052.098-.052h3.666c.024 0 .061.01.098.052a.3.3 0 0 1 .069.198v5.75a.5.5 0 0 0 .5.5H19a2 2 0 0 0 2-2v-9.272l.173.15a.5.5 0 1 0 .654-.756l-9.002-7.797A1.22 1.22 0 0 0 12 2.333m3 19v-5.25a1.3 1.3 0 0 0-.322-.862 1.13 1.13 0 0 0-.845-.388h-3.666c-.33 0-.632.148-.845.387a1.3 1.3 0 0 0-.322.863v5.25H5a1 1 0 0 1-1-1V10.199q.053-.046.097-.088l7.85-6.794L20 10.195v10.138a1 1 0 0 1-1 1z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHome;